module.exports = __webpack_public_path__ + "static/media/cwu_turbo.37fb7786.svg";